import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FeaturesReady } from '@growthbook/growthbook-react';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import Icon from 'dpl/common/components/Icon';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

import MobileFilterMenu from './MobileFilterMenu';
import SearchFilters from './SearchFilters';

const IS_LT_LG = isLessThanBreakpoint('lg');

export default function FilterPanel({
  shouldShowSort,
  resultsType,
  useFilterIcon,
  totalItemCount
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  function handleFilterButtonClick(e) {
    setIsMenuOpen(true);
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: e.target.textContent,
      view:
        resultsType === RESULTS_TYPES.PUPPIES
          ? ANALYTICS_VIEWS.PUPPY_SEARCH_RESULTS
          : ANALYTICS_VIEWS.BREEDER_SEARCH_RESULTS,
      view_feature: ANALYTICS_VIEW_FEATURES.SORT_FILTER_BUTTON,
      view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_HEADER
    });
  }

  const filterBtn = useFilterIcon ? (
    <button
      type="button"
      className="ba br-100 b--default pv2 ph2"
      onClick={e => handleFilterButtonClick(e)}
    >
      <Icon height="24px" name="fetch-filter" width="24px" />
    </button>
  ) : (
    <button
      type="button"
      className="w-100 flex mb6 mb10-sm ba b--light-gray justify-center items-center f2 f3-sm pv3 pv2-sm br3 fw-medium bg-near-white"
      onClick={e => handleFilterButtonClick(e)}
    >
      <Icon className="mr2" height="24px" name="filter" width="24px" />
      <span>{shouldShowSort ? 'Sort & filter' : 'Filter results'}</span>
    </button>
  );

  return (
    <div
      className={classnames('BreederSearchResultsFilterPanel', {
        'sticky top-0 pv5 nv5': !IS_LT_LG
      })}
    >
      {IS_LT_LG ? (
        <>
          {filterBtn}
          <FeaturesReady timeout={500}>
            <MobileFilterMenu
              shouldShowSort={shouldShowSort}
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen}
              totalItemCount={totalItemCount}
            />
          </FeaturesReady>
        </>
      ) : (
        <div>
          <SearchFilters />
        </div>
      )}
    </div>
  );
}

FilterPanel.propTypes = {
  shouldShowSort: PropTypes.bool,
  resultsType: PropTypes.string.isRequired,
  useFilterIcon: PropTypes.bool,
  totalItemCount: PropTypes.number.isRequired
};

FilterPanel.defaultProps = {
  shouldShowSort: false,
  useFilterIcon: false
};
